import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useParams } from 'react-router-dom'

import { EventMetadata } from '@newComponents/Event/EventMetadata'
import { NotFoundScreen } from '@newComponents/NotFoundScreen'
import { Screen } from '@newComponents'

import { getSlugFromPrettyUrl } from '@data/util/urlHelpers'

import { EventScreenNewDesktop } from './EventScreenNewDesktop'
import { EventScreenNewMobile } from './EventScreenNewMobile'

import { EventScreenNewQuery } from './__generated__/EventScreenNewQuery.graphql'

export const EventScreen = () => {
  const params = useParams<'eventId'>()

  const data = useLazyLoadQuery<EventScreenNewQuery>(
    graphql`
      query EventScreenNewQuery($slug: String!) {
        event: eventBySlug(slug: $slug) {
          ...EventMetadata_event
          ...EventScreenNewDesktop_event
          ...EventScreenNewMobile_event
        }

        ...EventScreenNewDesktop_query
        ...EventScreenNewMobile_query
      }
    `,
    { slug: getSlugFromPrettyUrl(params.eventId) }
  )

  if (!data.event) {
    return <NotFoundScreen />
  }

  return (
    <>
      <EventMetadata event={data.event} />

      <Screen>
        <EventScreenNewMobile event={data.event} query={data} />
        <EventScreenNewDesktop event={data.event} query={data} />
      </Screen>
    </>
  )
}

export default EventScreen
